import React from "react";
import CompanyPageLayout from "./CompanyPageLayout";

const ConfidentialiteEtDonnees = () => (
  <CompanyPageLayout pageTitle="Confidentialité et données" currentPath="/confidentialite-et-donnees" eyebrow="WEAVEVO · PRIVACY" title="Confidentialité et données" intro="Accédez à vos paramètres de confidentialité et téléchargez vos données personnelles.">
    <section className="cp-privacyAction">
      <div className="cp-privacyActionIcon" aria-hidden="true"><i className="bi bi-shield-lock" /></div>
      <h2>Confidentialité et données</h2>
      <p>Accédez à vos paramètres de confidentialité et téléchargez vos données personnelles.</p>
    </section>
  </CompanyPageLayout>
);

export default ConfidentialiteEtDonnees;
